import { AppSettings } from '../app.settings';
import { VehicleTransferScreenFiltersDataModel } from './vehicle-transfer-screen-filters-data-model';

export class VehicleTransferScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  filterData: VehicleTransferScreenFiltersDataModel = new VehicleTransferScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    filterData: VehicleTransferScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.filterData = options.filterData;
    }
  }
};
